exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-9cc9a546].v-data-table td,[data-v-9cc9a546].v-data-table th {\n  padding: 0 8px;\n}", ""]);

// exports
